<template>
  <div class="home">
    <a target="_blank" href="https://www.facebook.com/comissaodocrash/">
      <img class="social1"  src="../assets/facebook.png" alt="" width="100px">
    </a>
    <a target="_blank" href="https://www.instagram.com/comissaodocrash/">
      <img class="social2" src="../assets/instagram.png"  alt="" width="100px">
    </a>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {}
}
</script>


<style scoped lang="scss">
.home{
  width: 1920px;
  height: 1080px;
  background-image: url('../assets/fundo.png');
  background-size: cover;
  .mascotes {
    position: absolute;
    left: 55px;
    bottom: 30px;
  }
.social1{
  position: absolute;
  left: 510px;
  bottom: 35px;
  border: 5px solid white;
  border-radius: 20px;
}
.social2{
  position: absolute;
  left: 650px;
  bottom: 35px;
  border: 5px solid white;
  border-radius: 20px;  
}
  
  
}
</style>